import { Modal, Button, Divider } from "antd";
import React, { useState } from "react";
import { AiFillEye } from "react-icons/ai";
import TextInfo from "../../../../components/common/TextInfo/TextInfo";
import DetailCampaignDialog from "../DetailCampaignDialog";

import "./styles.css";

const DetailDialog = ({
  visible,
  setVisible,
  handleCancel,
  handlePrint,
  data,
  type,
}) => {
  const [campaignDetailDialog, setCampaiganDetailDialog] = useState(false);

  const onClickDetailCampaign = () => {
    setCampaiganDetailDialog(true);
    setVisible(false);
  };

  const handleCloseDetailCampaign = () => {
    setCampaiganDetailDialog(false);
    setVisible(true);
  };

  const nonTunaiDetail = (
    <>
      <TextInfo title="Bank" value={data?.customerBankName} />
      <TextInfo title="No. Rekening" value={data?.customerAccountNumber} />
      <TextInfo title="Atas Nama" value={data?.customerAccountName} />
    </>
  );

  const paymentDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Nilai Pinjaman" value={data?.loanAmount} />
      <TextInfo title="Denda Keterlambatan" value={data?.lateFine} />
      <TextInfo
        title={
          type === "pawn" ? "Penyimpanan Keterlambatan" : "Biaya Penyimpanan"
        }
        value={data?.lateStorageFee}
      />
      <TextInfo title="Potongan Voucher" value={data?.voucher} />
      <TextInfo title="Total Pembayaran" value={data?.totalPayment} />
      <div className="modal-title">Promo yang Digunakan</div>
      <div
        style={{ display: "flex", gap: "5px", cursor: "pointer" }}
        onClick={onClickDetailCampaign}
      >
        : <div>{data?.offerName || "-"}</div>
        <AiFillEye
          style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }}
        />
      </div>
    </div>
  );

  const loanDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      {type === "pawn" && (
        <TextInfo title="Nilai Valuasi" value={data?.valuationValue} />
      )}
      <TextInfo title="Nilai Pinjaman" value={data?.loanAmount} />
      <TextInfo title="Sewa Modal" value={data?.loanCapital} />
      <TextInfo title="Biaya Administrasi" value={data?.adminFee} />
      <TextInfo
        title="Biaya Simpan & Asuransi"
        value={data?.storeAndInsuranceFee}
      />
      <TextInfo title="Denda Keterlambatan" value={data?.lateFine} />
      <TextInfo title="Denda Penyimpanan" value={data?.lateStorageFee} />
      <TextInfo title="Biaya Transfer" value={data?.transferFee} />
      <TextInfo title="Jumlah Diterima" value={data?.amountReceived} />
      <div className="modal-title">Promo yang Digunakan</div>
      <div
        style={{ display: "flex", gap: "5px", cursor: "pointer" }}
        onClick={onClickDetailCampaign}
      >
        : <div>{data?.offerName || "-"}</div>
        <AiFillEye
          style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }}
        />
      </div>
    </div>
  );

  const installment = (
    <>
      {data?.paymentMethod?.toLowerCase() !== "cash" &&
        <>
          <div className="detail-content">
            {nonTunaiDetail}
          </div>
          <Divider dashed className="detail-divider" />
        </>
      }
      {data?.transactionInstallment && data?.transactionInstallment?.length > 0 &&
        data?.transactionInstallment.map((item, index) => {
          return (
            <div key={index}>
              <div className="my-2">Tagihan Cicilan ke-{item?.periodNumber}</div>
              <div className="detail-content">
                <TextInfo title="Periode" value={item?.period} />
                <TextInfo title="No. Kwitansi" value={item?.receipt} />
                <TextInfo title="Tagihan Pokok" value={item?.installmentAmount} />
                {
                  data.offerInterestExpenseType.includes('behind') &&
                  <>
                    <TextInfo title="Sewa Modal" value={item?.loanCapital} />
                    {item.interestType === 'behind' && <>
                      <TextInfo title="Biaya Administrasi" value={item?.feeAdmin} />
                      <TextInfo
                        title="Biaya Simpan & Asuransi"
                        value={item?.feeSavingInsurance}
                      />
                    </>}
                  </>
                }
                <TextInfo title="Denda Harian" value={item?.lateDays} />
                <TextInfo title="Biaya Keterlambatan" value={item?.latePeriod} />
                <TextInfo title="Total" value={item?.total} />
              </div>
              <Divider dashed className="detail-divider" />
            </div>
          )
        })
      }
      <div className="detail-content">
        <TextInfo title="Potongan Voucher" value={data?.voucher} />
        <TextInfo title="Total Pembayaran" value={data?.totalPayment} />
        <div className="modal-title">Promo yang Digunakan</div>
        <div
          style={{ display: "flex", gap: "5px", cursor: "pointer" }}
          onClick={onClickDetailCampaign}
        >
          : <div>{data?.offerName || "-"}</div>
          <AiFillEye
            style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }}
          />
        </div>
      </div>
    </>
  );

  const extensionDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Sewa Modal" value={data?.loanCapital} />
      <TextInfo title="Administrasi" value={data?.adminFee} />
      <TextInfo title="Simpan & Asuransi" value={data?.storeAndInsuranceFee} />
      <TextInfo
        title="Biaya Nilai Revaluasi"
        value={data?.revaluationValueFee}
      />
      <TextInfo title="Denda Keterlambatan" value={data?.lateFine} />
      <TextInfo title="Denda Penyimpanan" value={data?.lateStorageFee} />
      <TextInfo title="Potongan Voucher" value={data?.voucher} />
      <TextInfo title="Total Pembayaran" value={data?.totalPayment} />
      <div className="modal-title">Promo yang Digunakan</div>
      <div
        style={{ display: "flex", gap: "5px", cursor: "pointer" }}
        onClick={onClickDetailCampaign}
      >
        : <div>{data?.offerName || "-"}</div>
        <AiFillEye
          style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }}
        />
      </div>
    </div>
  );

  const lelangDetail = (
    <div className="detail-content">
      {/* {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail} */}
      <TextInfo title="Nilai Pinjaman" value={data?.loanAmount} />
      <TextInfo title="Biaya Lelang" value={data?.auctionFee} />
      <TextInfo title="Biaya Lain-lain" value={data?.auctionOtherFee} />
      <TextInfo title="Denda Keterlambatan" value={data?.lateFine} />
      <TextInfo title="Denda Penyimpanan" value={data?.lateStorageFee} />
      <TextInfo title="Nilai Lelang" value={data?.auctionPrice} />
      <TextInfo title="Total Bayar" value={data?.totalPayment} />
      <TextInfo title="Deskripsi" value={data?.auctionDescription} />

      {/* <TextInfo title="Biaya Jasa Lelang" value={data?.auctionServiceFee} />
      <TextInfo title="Harga Lelang" value={data?.auctionPrice} />
      <TextInfo title="Sisa Lelang" value={data?.auctionRemaining} />
      <TextInfo title="Promo yang Digunakan" value={data?.offerName} /> */}
    </div>
  );

  const auctionLost = (
    <div className="detail-content">
      <TextInfo title="Total Bayar" value={data?.itemValue} />
      <TextInfo title="Nilai Lelang" value={data?.auctionPrice} />
      <TextInfo title="Deskripsi" value={data?.auctionDescription} />
      <TextInfo title="Kerugian" value={data?.totalPayment} />

      {/* <TextInfo title="Biaya Jasa Lelang" value={data?.auctionServiceFee} />
      <TextInfo title="Harga Lelang" value={data?.auctionPrice} />
      <TextInfo title="Sisa Lelang" value={data?.auctionRemaining} />
      <TextInfo title="Promo yang Digunakan" value={data?.offerName} /> */}
    </div>
  );

  const refundDetail = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Jenis Pengembalian" value={data?.returnType} />
      <TextInfo title="Keterangan" value={data?.description} />
      <TextInfo title="Jumlah Pengembalian" value={data?.returnTotal} />{" "}
      <div className="modal-title">Promo yang Digunakan</div>
      <div
        style={{ display: "flex", gap: "5px", cursor: "pointer" }}
        onClick={onClickDetailCampaign}
      >
        : <div>{data?.offerName || "-"}</div>
        <AiFillEye
          style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }}
        />
      </div>
    </div>
  );

  const latePayment = (
    <div className="detail-content">
      {data?.paymentMethod?.toLowerCase() !== "cash" && nonTunaiDetail}
      <TextInfo title="Denda Keterlambatan" value={data?.lateFine} />
      <TextInfo title="Denda Penyimpanan" value={data?.lateStorageFee} />
      <TextInfo title="Total Denda" value={data?.totalFine} />
      <div className="modal-title">Promo yang Digunakan</div>
      <div
        style={{ display: "flex", gap: "5px", cursor: "pointer" }}
        onClick={onClickDetailCampaign}
      >
        : <div>{data?.offerName || "-"}</div>
        <AiFillEye
          style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }}
        />
      </div>
      {/* <TextInfo title="Promo yang Digunakan" value={data?.offerName} /> */}
    </div>
  );

  const renderDetail = () => {
    if (data?.offer?.paymentType === 'Installment' && data?.transactionType?.toLowerCase() === "payment-loan") {
      return installment;
    } else if (data?.transactionType.toLowerCase() === "disburse-loan") {
      return loanDetail;
    } else if (data?.transactionType.toLowerCase() === "payment-loan") {
      return paymentDetail;
    } else if (data?.transactionType.toLowerCase() === "extension") {
      return extensionDetail;
    } else if (data?.transactionType.toLowerCase() === "auction") {
      return lelangDetail;
    } else if (data?.transactionType.toLowerCase() === "auction-loss") {
      return auctionLost;
    } else if (data?.transactionType.toLowerCase() === "refund") {
      return refundDetail;
    } else if (data?.transactionType.toLowerCase() === "late-payment") {
      return latePayment;
    }
  };

  return (
    <>
      <Modal
        className="modal-detail"
        title="Detail Transaksi"
        visible={visible}
        onCancel={handleCancel}
        width={500}
        centered
        footer={[
          <Button
            key="back"
            onClick={handlePrint}
            className="btn-modal btn-default"
          >
            Cetak Nota
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleCancel}
            className="btn-modal"
          >
            Selesai
          </Button>,
        ]}
      >
        <div id="printable">
          <div className="detail-header">
            <TextInfo title="Tanggal/Waktu" value={data?.dateTime || "-"} />
            <div className="modal-title">No. Surat Bukti Gadai</div>
            <div
              style={{ display: "flex", gap: "5px", cursor: "pointer" }}
              onClick={() =>
                window.open(`/sbg-private/${data.gadaiID || 0}`, "_blank")
              }
            >
              : <div>{data?.gadaiCode || "-"}</div>
              <AiFillEye
                style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }}
              />
            </div>
            {
              data?.offer?.paymentType !== 'Installment' && data?.transactionType?.toLowerCase() !== "payment-loan" &&
              <TextInfo title="No. Kwitansi" value={data?.receiptNumber || "-"} />
            }
            <TextInfo title="Nama Nasabah" value={data?.customerName || "-"} />
            {data?.transactionType !== "lelang" && (
              <TextInfo title="Nama Officer" value={data?.officerName || "-"} />
            )}
          </div>
          <Divider dashed className="detail-divider" />
          {!data || !Object.keys(data).length
            ? "Tidak ada data"
            : renderDetail()}
          <Divider dashed className="detail-divider" />
          <div className="detail-footer">
            <div>
              Cetak dan simpan nota ini sebagai bukti pencairan pinjaman dan
              transaksi yang sah.
            </div>
            <div>PT. deGadai Solusi Utama</div>
          </div>
        </div>
      </Modal>
      <DetailCampaignDialog
        visible={campaignDetailDialog}
        handleCancel={handleCloseDetailCampaign}
        data={data}
      />
    </>
  );
};

export default DetailDialog;
